import { dom } from 'react-redux-app/lib/modules/core/utils';
import { SESSION_STORAGE, setItem } from 'react-redux-app/lib/modules/storage';
import { actionAddGlobalError } from 'react-redux-app/lib/modules/globalError/actions';

import { getUri } from 'react-redux-app/lib/modules/routing/utils';
import { getLangFromRequestUri } from '../core/i18n/utils';
import { getLoginUrl } from '../auth/utils';
import {
  getUnsuspendPageUrl,
  getSitesUrl,
} from './utils/siteUrls';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import {
  API_BAD_REQUEST_ERROR,
  API_FORBIDDEN_ERROR,
  API_NOT_FOUND_ERROR,
  API_UNAUTHORIZED_ERROR,
  API_UNKNOWN_ERROR,
  API_BAD_REQUEST_BODY_ERROR,
  API_OPERATION_FAILED_ERROR,
  WEBMASTER_NOT_FOUND,
} from '../core/api/constants/errors';
import { STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL } from '../auth/constants';


const getApiCriticalErrorHandlers = reduxStore => (location, redirectFunction) => ({
  [API_BAD_REQUEST_ERROR]: () => redirectFunction(INTERNAL_ERROR_URI),
  [API_FORBIDDEN_ERROR]: () => {
    dom.redirect(getUnsuspendPageUrl(getLangFromRequestUri(getUri(location))));
  },
  [API_NOT_FOUND_ERROR]: () => redirectFunction(INTERNAL_ERROR_URI),
  [API_UNKNOWN_ERROR]: () => redirectFunction(INTERNAL_ERROR_URI),
  [API_UNAUTHORIZED_ERROR]: () => {
    const currentLocation = getUri(location);
    setItem(SESSION_STORAGE, STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL, currentLocation);
    dom.redirect(getLoginUrl(reduxStore.getState(), getLangFromRequestUri(currentLocation)));
  },
  [API_BAD_REQUEST_BODY_ERROR]: () => redirectFunction(INTERNAL_ERROR_URI),
  [API_OPERATION_FAILED_ERROR]: () => redirectFunction(INTERNAL_ERROR_URI),
  [WEBMASTER_NOT_FOUND]: () => {
    const currentLocation = getUri(location);
    const lang = getLangFromRequestUri(currentLocation);
    reduxStore.dispatch(
      actionAddGlobalError({
        text: { id: 'error.webmaster.other-logged' },
        redirectUrl: currentLocation.includes('/sites/') ? getSitesUrl(lang) : currentLocation,
      })
    );
  },
});

export default getApiCriticalErrorHandlers;
